export default "__VITE_ASSET__78e33e24__"